import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';
interface FeatureCardProps {
  icon: ReactNode;
  title: string;
  description: string;
  className?: string;
  delay?: number;
}
export function FeatureCard({
  icon,
  title,
  description,
  className,
  delay = 0
}: FeatureCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className={cn('bg-white p-6 rounded-xl shadow-md border border-slate-100 hover:shadow-lg transition-shadow', className)} data-id="element-276">
      <div className="h-12 w-12 rounded-lg bg-emerald-100 flex items-center justify-center text-emerald-600 mb-4" data-id="element-277">
        {icon}
      </div>
      <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-278">{title}</h3>
      <p className="text-slate-600 text-sm leading-relaxed" data-id="element-279">{description}</p>
    </motion.div>;
}